'use strict'
const addComponentEventListener = require('./addComponentEventListener')
const getPage = require('../dataset-controller/rootReducer').getPaginationData
const { getCurrentPage } = require('../dataset-controller/rootReducer')

module.exports = ({ datasetApi, getState, errorBoundaries }) => {
  const beginningOfPage = (pageNumber, pageSize) => pageSize * (pageNumber - 1)

  const refreshView = ({ component: pagination }) => {
    const totalPages = datasetApi.getTotalPageCount()
    const currentPage = getCurrentPage(getState())
    pagination.totalPages = totalPages
    pagination.currentPage = currentPage
  }

  return {
    isValidContext() {
      return true
    },

    // Initial setting of values + binding the event handler
    bindToComponent({ component }) {
      addComponentEventListener(
        component,
        'onChange',
        event => {
          const requestedPage = event.target.currentPage
          const page = getPage(getState())
          const totalPages = datasetApi.getTotalPageCount()

          if (requestedPage < 1) {
            datasetApi.setCurrentItemIndex(0)
          } else if (requestedPage > totalPages) {
            datasetApi.setCurrentItemIndex(
              beginningOfPage(totalPages, page.size)
            )
          } else {
            datasetApi.setCurrentItemIndex(
              beginningOfPage(requestedPage, page.size)
            )
          }
        },
        errorBoundaries
      )
    },

    currentRecordModified: () => {},

    // These are both important -> don't need to set handler again, but need to
    // re-set values
    recordSetLoaded: refreshView,

    currentViewChanged: refreshView,

    currentIndexChanged: () => {}
  }
}



// WEBPACK FOOTER //
// ./adapters/paginationAdapter.js